import type { UntitledIconData } from '../../UntitledIconData'

export const ulChevronRight: UntitledIconData = {
  prefix: 'ul',
  name: 'chevron-right',
  paths: [
    {
      shape: 'M9 18L15 12L9 6',
    },
  ],
}
